import { request } from '@src/core/api/request';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from '@src/core/api/query-client';

import { QUERY_KEYS } from '@shared/constants/query-keys';

import type { TMember } from '../types/member';
import { useAuthStore } from '@src/core/store/auth-store';

export const getMembershipsData = async (): Promise<TMember[]> => {
  return request({ url: 'members/memberships/' });
};

export const useGetMemberships = (
  options?: Partial<UseQueryOptions<TMember[]>>
) => {
  const { accessToken } = useAuthStore();

  const data = useQuery({
    queryKey: [QUERY_KEYS.getMemberships],
    queryFn: getMembershipsData,
    enabled: !!accessToken,
    staleTime: Infinity,
    ...options,
  });

  return data;
};

export const getCachedMemberships = () => {
  const user = queryClient.getQueryData<TMember[]>([QUERY_KEYS.getMemberships]);
  return user;
};
